/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class Properties
 * @hideconstructor
 * @classdesc API class that is used to manage Properties
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./PropertiesPaneAPI',
	'../../../app/nls/StringResources',
	'../../../app/util/ErrorUtils',
	'../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI'
], function(APIFactory, PropertiesPaneAPI, StringResources, ErrorUtils, ContentActionsProviderAPI) {

	const PROVIDER_ID = 'PropertiesPane';

	class PropertiesPane {
		constructor({ features }) {
			this._dashboardApi = features.API;
			this._slideout = features.InAppSlideoutState;
			this._dashboardState = features.DashboardState;
			this._icons = features.Icons;
			this._api = null;
		}

		getAPI() {
			return this._api;
		}

		getProviderId() {
			return PROVIDER_ID;
		}

		initialize() {
			this._api = APIFactory.createAPI(this, [PropertiesPaneAPI]);

			const uiState = this._dashboardState.getUiState();
			this._slideout.registerContribution(this.getProviderId(), {
				name: 'properties',
				label: StringResources.get('commonPropertiesLabel'),
				icon: this._icons.getIcon('configure').id,
				type: 'Button',
				section: ContentActionsProviderAPI.ACTION_SECTION.PANEL,
				order: 40,
				text: StringResources.get('commonPropertiesLabel'),
				className: 'buttonWithText',
				disabled: () => uiState.eventGroups,
				isEnabled: () => {
					const shouldPropertiesActionInToolbar = ErrorUtils.hasCapability(this._dashboardApi, 'canAuthorDashboard')
						&& uiState.authoring;
					return shouldPropertiesActionInToolbar;
				}
			});
		}

		destroy() {
			this._dashboardApi = null;
			this._api = null;
		}
	}

	return PropertiesPane;
});
